var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-notfound text-center"},[_c('v-row',[_c('v-col',[_c('h3',[_vm._v("I am extremely disappointed, this route does not exist!")]),_vm._v(" Redirection in 5 seconds ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }